import {
  IFileGateway,
  IUserGateway,
  PresenterFunc,
  UpdaterFunc,
  UserInput,
} from '@/core/interface';
import { User } from '@/core/entity';
import { Fragment } from '@/core/interface/common';

export class CreateUser {
  constructor(
    private readonly fileGateway: IFileGateway,
    private readonly userGateway: IUserGateway,
  ) { }

  public async execute(
    input: UserInput,
    presenter: PresenterFunc<User | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      let uploadItem = null;
      if (input.avatar instanceof File) {
        uploadItem = await this.userGateway.getUserAvatarUploadUrl(input.avatar.type);

        await this.fileGateway.upload(input.avatar, uploadItem.uploadUrl);

        input.avatar = uploadItem.fileUri;
      }

      const result = await this.userGateway.createUser(input, fragment, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
